import React, { useState } from 'react';
import styled from 'styled-components';
import AuthBackgroundLogo from '../../components/auth/AuthBackgroundLogo';
import AuthLogo from '../../components/auth/AuthLogo';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoginPageUrl } from '../../url/poenUrl';
import AuthService from '../../api/service/auth/AuthService';
import LoadingOverlay from '../../components/LoadingOverlay';
import PermissionRedirect from '../../components/PermissionRedirect';

const Container = styled.div`
  padding: 20px;
  font-family: 'Pretendard', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #fff;
  position: relative;
`;

const Title = styled.p`
  font-size: 14px;
  color: #666;
  text-align: center;
  margin-bottom: 30px;
  line-height: 1.5;
`;

const ResultBox = styled.div`
  width: 100%;
  max-width: 360px;
  padding: 30px;
  border: 1px solid #ccc;
  text-align: center;
  margin-bottom: 20px;
`;

const IdText = styled.p`
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0;
  color: #333;
  background-color: #ddd;
  padding: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  max-width: 360px;
`;

const Button = styled.button`
  flex: 1;
  padding: 12px;
  border: none;
  font-size: 14px;
  cursor: pointer;
  color: white;
  background-color: ${({ theme }) => theme.colors.mainColor};

  &:hover {
    background-color: ${({ theme }) => theme.colors.hoverColor};
  }
`;

const GreenButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.subColor};

  &:hover {
    background-color: ${({ theme }) => theme.colors.subHoverColor};
  }
`;

const ResultIdPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // 전달된 데이터 가져오기
  const { identifier, name, email } = location.state || {
    identifier: '아이디를 찾을 수 없습니다.',
  };

  // 로딩 상태 추가
  const [isLoading, setIsLoading] = useState(false);

  const handleSendEmail = async () => {
    if (!name || !email) {
      alert('이름과 이메일 정보가 없습니다.');
      return;
    }

    setIsLoading(true); // 로딩 시작

    try {
      const response = await AuthService.identifierSend({ name, email });
      alert('아이디 이메일로 전송되었습니다.');
      console.log('전송 성공:', response);
    } catch (error) {
      console.error('아이디 이메일 전송 실패:', error);
      alert(error);
    } finally {
      setIsLoading(false); // 로딩 종료
    }
  };

  return (
    <Container>
      <PermissionRedirect />
      {isLoading && <LoadingOverlay />}
      <AuthLogo title="아이디 찾기" />
      <Title>
        고객님은 이미 회원가입이 되어 있습니다. <br />
        아이디 확인 후 로그인해 주세요.
      </Title>
      <ResultBox>
        <p>확인된 아이디</p>
        <IdText>{identifier}</IdText>
      </ResultBox>
      <ButtonContainer>
        <Button onClick={handleSendEmail}>아이디 이메일로 전송</Button>
        <GreenButton onClick={() => navigate(LoginPageUrl)}>로그인</GreenButton>
      </ButtonContainer>
      <AuthBackgroundLogo />
    </Container>
  );
};

export default ResultIdPage;
